import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch, ComponentPublicInstance } from "vue";
import { WorkSchedule } from "../UserMasterWorkSchedule";
import WorkScheduleForm from "./WorkScheduleForm.vue";

type Props = {
  item: WorkSchedule;
  items: WorkSchedule[];
  affiliationId?: number;
};
type Emits = {
  (e: "input", value: boolean): void;
  (e: "click", val: WorkSchedule): void;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'WorkScheduleDialogEdit',
  props: {
    item: null,
    items: null,
    affiliationId: null
  },
  emits: ["input", "click"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: "input", value: boolean): void;
  (e: "click", val: WorkSchedule): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  item: WorkSchedule;
  items: WorkSchedule[];
  affiliationId?: number;
};




const vform = ref<ComponentPublicInstance<typeof WorkScheduleForm>>();
const item = ref<WorkSchedule>({});

const isOpen = ref(false);

const editItems = computed(() => {
  const shiftPatternId = props.item.shiftPatternId;
  const weekday = props.item.weekday;
  return props.items.filter(
    e => !(e.shiftPatternId === shiftPatternId && e.weekday === weekday)
  );
});

const onClose = () => {
  isOpen.value = false;
};

const onClick = () => {
  if (!vform.value?.validate()) return;
  onClose();
  emits("click", item.value);
};

watch(
  isOpen,
  () => {
    item.value = Object.assign({}, props.item);
  },
  { immediate: true }
);

return { __sfc: true,props, emits, vform, item, isOpen, editItems, onClose, onClick, WorkScheduleForm }
}

})